import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import SuggestionWidget from "./components/SuggestionWidget/SuggestionWidget.jsx";

const container = document.getElementById("suggestions-widget-container");
const configContainer = document.getElementById("suggestions-widget-config");
let configuration = "";
if (configContainer) {
  configuration = JSON.parse(configContainer.innerText);
}

if (container) {
  const root = createRoot(container);
  root.render(
    <div className="suggestions_widget-container">
      <SuggestionWidget config={configuration} />
    </div>
  );
}
